import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { StatItem } from '../../home.models';

@Component({
  selector: 'app-home-metrics-section',
  standalone: true,
  templateUrl: './metrics-section.component.html'
})
export class MetricsSectionComponent {
  @ViewChild('statsBlock') statsBlock!: ElementRef<HTMLElement>;

  @Input({ required: true }) stats: StatItem[] = [];
  @Input({ required: true }) currentValues: number[] = [];
}
